import { OwaDate, owaDate, isAfter } from 'owa-datetime';
import type { OwaDateRange } from '../OwaDateRange';
import owaDateFromTzDateTimeValues from './owaDateFromTzDateTimeValues';

/**
 * This function returns new start and end time based on the passed-in time zones
 * It updates the start and end times to match the existing times in the newly selected time zones
 */
export default function getDatesOnStartTimeZoneChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newStartTimeZone: string,
    newEndTimeZone: string
): OwaDateRange {
    if (prevStartDate && prevEndDate && newStartTimeZone && newEndTimeZone) {
        let newStart = owaDateFromTzDateTimeValues(newStartTimeZone, prevStartDate, prevStartDate);
        let newEnd = owaDateFromTzDateTimeValues(newEndTimeZone, prevEndDate, prevEndDate);

        if (isAfter(newStart, newEnd)) {
            // If new end is set to something before start, then update end to be start
            newEnd = owaDate(newEndTimeZone, newStart);
        }

        return {
            start: newStart,
            end: newEnd,
        };
    }
    return null;
}
